export default {
  action_plan: 'Plan de acción',
  // Date Time
  month: 'mes',
  month_plural: 'meses',
  day: 'día',
  day_plural: 'días',
  hour: 'hora',
  hour_plural: 'horas',
  minute: 'minuto',
  minute_plural: 'minutos',

  // Profiles
  'profiles.owner': 'Propietario',
  'profiles.thirdParty': 'Tercero',
  'profiles.thirdPartyUser': 'Usuario de Tercero',
  'profiles.user': 'Usuario',
  'profiles.administrator': 'Administrador',
  'profiles.administrative': 'Administrativo',

  // Filters
  'filter.typeIds': '{{count}} tipos',
  'filter.typeIds_plural': '{{count}} tipos',
  'filter.groupIds': '{{count}} grupo',
  'filter.groupIds_plural': '{{count}} grupos',
  'filter.profileIds': '{{count}} perfil',
  'filter.profileIds_plural': '{{count}} perfiles',
  'filter.entityCompanId': '{{count}} proyecto',
  'filter.entityCompanId_plural': '{{count}} proyectos',
  'filter.checkList': '{{count}} cuestionario',
  'filter.checkListIds': '{{count}} cuestionario',
  'filter.checkList_plural': '{{count}} cuestionarios',
  'filter.checkListIds_plural': '{{count}} cuestionarios',
  'filter.serviceId_plural': '{{count}} cuestionarios',
  'filter.entityChecklistIds': '{{count}} cuestionario',
  'filter.entityChecklistIds_plural': '{{count}} cuestionarios',
  'filter.checkLists': '{{count}} cuestionario',
  'filter.checklistIds': '{{count}} cuestionario',
  'filter.checkLists_plural': '{{count}} cuestionarios',
  'filter.checklistIds_plural': '{{count}} cuestionarios',
  'filter.checklist': '{{count}} cuestionario',
  'filter.checklist_plural': '{{count}} cuestionarios',
  'filter.service': '{{count}} cuestionario',
  'filter.service_plural': '{{count}} cuestionarios',
  'filter.questions': '{{count}} pregunta',
  'filter.questions_plural': '{{count}} preguntas',
  'filter.questionIds': '{{count}} pregunta',
  'filter.questionIds_plural': '{{count}} preguntas',
  'filter.serviceType.id': '{{count}} tipo de cuestionario',
  'filter.serviceType.id_plural': '{{count}} tipos de cuestionario',
  'filter.placeLevel': '{{count}} seleccionado',
  'filter.placeLevel_plural': '{{count}} seleccionados',
  'filter.placeLevels': '{{count}} nivel de local/persona',
  'filter.placeLevels_plural': '{{count}} niveles de locales/personas',
  'filter.placeLevelIds': '{{count}} seleccionado',
  'filter.placeLevelIds_plural': '{{count}} seleccionados',
  'filter.places': '{{count}} local/persona',
  'filter.places_plural': '{{count}} locales/personas',
  'filter.placeIds': '{{count}} local/persona',
  'filter.placeIds_plural': '{{count}} locales/personas',
  'filter.placeId_plural': '{{count}} locales/personas',
  'filter.entityPlaceIds': '{{count}} local/persona',
  'filter.entityPlaceIds_plural': '{{count}} locales/personas',
  'filter.place': '{{count}} local/persona',
  'filter.place_plural': '{{count}} locales/personas',
  'filter.statusNames': '{{count}} estado',
  'filter.statusIds_plural': '{{count}} estados',
  'filter.userIds': '{{count}} usuario',
  'filter.userIds_plural': '{{count}} usuarios',
  'filter.assetIds': '{{count}} activo',
  'filter.assetIds_plural': '{{count}} activos',
  'filter.semaphoreKeys': '{{count}} semáforo',
  'filter.semaphoreKeys_plural': '{{count}} semáforos',
  'filter.userId_plural': '{{count}} usuarios',
  'filter.user': '{{count}} usuario',
  'filter.users_plural': '{{count}} usuarios',
  'filter.entityUserIds': '{{count}} usuario',
  'filter.createdByIds': 'Creado por {{count}} usuario',
  'filter.createdByIds_plural': 'Creado por {{count}} usuarios',
  'filter.entityUserIds_plural': '{{count}} usuarios',
  'filter.group.id': '{{count}} grupo',
  'filter.group.id_plural': '{{count}} grupos',
  'filter.role.id': '{{count}} perfil',
  'filter.role.id_plural': '{{count}} perfiles',
  'filter.servieOrder': '{{count}} actividad',
  'filter.servieOrder_plural': '{{count}} actividades',
  'filter.entityServiceOrderIds': '{{count}} actividad',
  'filter.entityServiceOrderIds_plural': '{{count}} actividades',
  'filter.servieOrder.id': '{{count}} actividad',
  'filter.servieOrder.id_plural': '{{count}} actividades',
  'filter.refundType.id': '{{count}} tipo de reembolso',
  'filter.refundType.id_plural': '{{count}} tipos de reembolso',
  'filter.levels': '{{count}} niveles',
  'filter.origins': '{{count}} orígenes',

  // Entities
  'entity.asset': 'Activo',
  'entity.formReply': 'Respuestas de formulario',
  'entity.serviceOrder': 'Actividad',
  'entity.serviceOrder_plural': 'Actividades',
  'entity.user': 'Usuarios',
  'entity.service': 'Cuestionarios',
  'entity.checkList': 'Cuestionarios',
  'entity.checklist': 'Cuestionarios',
  'entity.refund': 'Reembolsos',
  'entity.person': 'Personas',
  'entity.fleet': 'Flotas',
  'entity.location': 'Locales',
  'entity.form': 'Formulario',
  'entity.actionPlan': 'Plan de acción',

  // Field types
  'fieldTypes.action_plan': 'Plan de acción',
  'fieldTypes.block': 'Bloque',
  'fieldTypes.asset': 'Activo',
  'fieldTypes.user': 'Usuario',
  'fieldTypes.checkbox': 'Sí o No',
  'fieldTypes.compliance': 'Conformidad',
  'fieldTypes.cpf_cnpj': 'Documento',
  'fieldTypes.gallery': 'Anexos',
  'fieldTypes.location': 'Dirección',
  'fieldTypes.numeric': 'Numérico',
  'fieldTypes.multiple': 'Elección múltiple',
  'fieldTypes.stock': 'Inventario',
  'fieldTypes.pending': 'Pendencia',
  'fieldTypes.select': 'Selección única',
  'fieldTypes.sign': 'Firma',
  'fieldTypes.signature': 'Firma (perfil)',
  'fieldTypes.system_status': 'Estado del sistema',
  'fieldTypes.address': 'Dirección',
  'fieldTypes.integer': 'Número',
  'fieldTypes.number': 'Número',
  'fieldTypes.float': 'Decimal',
  'fieldTypes.text': 'Texto',
  'fieldTypes.date': 'Fecha',
  'fieldTypes.time': 'Hora',
  'fieldTypes.datetime': 'Fecha y Hora',
  'fieldTypes.email': 'Email',
  'fieldTypes.picture': 'Imagen',
  'fieldTypes.file': 'Archivo',
  'fieldTypes.phoneNumber': 'Teléfono',
  'fieldTypes.place': 'Local',
  'fieldTypes.place_location': 'Locales',
  'fieldTypes.place_person': 'Personas',
  'fieldTypes.place_fleet': 'Flota',
  'fieldTypes.tags': 'Etiquetas',
  'fieldTypes.assets': 'Activos',
  'fieldTypes.informative': 'Informativa',
  'fieldTypes.calc': 'Cálculo',
  'fieldTypes.integration': 'Integración',
  'fieldTypes.coordinates': 'Coordenadas',
  'fieldTypes.validation_code': 'Código de validación',

  // Field types descriptions for tooltips
  'fieldTypes.action_plan.description': 'Campo para crear planes de acción y realizar seguimiento de pendencias.',
  'fieldTypes.block.description': 'Agrupa preguntas en formato de tabla para items del tema.',
  'fieldTypes.asset.description': 'Selección de item registrado para seguimiento de recursos.',
  'fieldTypes.checkbox.description':
    'Dos opciones fijas predefinidas y editables (Conforme/No Conforme). *Contiene lógica.',
  'fieldTypes.date.description': 'Campos de formato fecha y hora para selección.',
  'fieldTypes.datetime.description': 'Campos de formato fecha y hora para selección.',
  'fieldTypes.time.description': 'Campo para selección de hora.',
  'fieldTypes.gallery.description': 'Adjunte fotos o archivos .docx, .xlsx, .pptx y PDF.',
  'fieldTypes.pending.description': 'Campo para registrar pendencias y seguimiento.',
  'fieldTypes.multiple.description': 'Seleccione una o varias opciones de la lista predefinida. *Contiene lógica',
  'fieldTypes.stock.description': 'Actualiza automáticamente el control de inventario.',
  'fieldTypes.select.description': 'Permite elegir solo una opción de la lista predefinida. *Contiene lógica',
  'fieldTypes.sign.description': 'Campo para firma digital por el usuario.',
  'fieldTypes.signature.description': 'Firma almacenada en el perfil del usuario (dibujar y guardar en PNG).',
  'fieldTypes.address.description': 'Campo para completar dirección completa.',
  'fieldTypes.location.description': 'Captura ubicación mediante Google Maps con geolocalización.',
  'fieldTypes.numeric.description': 'Campo exclusivo para números enteros. *Contiene lógica',
  'fieldTypes.float.description': 'Acepta números con o sin coma. *Contiene lógica',
  'fieldTypes.text.description': 'Campo libre para insertar información textual.',
  'fieldTypes.place.description': 'Seleccione locales registrados previamente en la plataforma. *Contiene lógica',
  'fieldTypes.tags.description': 'Campo para clasificación con etiquetas.',
  'fieldTypes.informative.description': 'Muestra instrucciones o avisos sin interacción del usuario.',
  'fieldTypes.user.description': 'Seleccione usuarios registrados previamente en la plataforma.',
  'fieldTypes.calc.description': 'Ejecuta cálculos automáticos numéricos mediante fórmula. *Contiene lógica',
  'fieldTypes.integration.description': 'Contacte a nuestro equipo técnico para traer información externa.',
  'fieldTypes.cpf_cnpj.description': 'Inserción y validación automática de CPF o CNPJ.',
  'fieldTypes.coordinates.description': 'Captura su ubicación actual en el momento de la respuesta.',
  'fieldTypes.validation_code.description': 'Campo para ingresar un código validado contra la actividad.',

  'fieldTypes.cCodCateg': 'Categoría',
  'fieldTypes.nCodCC': 'Cód. Cuenta Corriente',
  'fieldTypes.nQtdeParc': 'Cantidad de Cuotas',
  'fieldTypes.cCodServMun': 'Cód. Servicio o CNAE',
  'fieldTypes.cCodServLC116': 'Cód. Servicio LC 116',
  'fieldTypes.cTribServ': 'Tributación de los Servicios',
  'fieldTypes.codVend': 'Vendedores',
  'fieldTypes.projects': 'Proyectos',
  'fieldTypes.documentType': 'Tipo de documento',

  // Conditions
  'conditions.operators.eq': 'Igual a',
  'conditions.operators.neq': 'Diferente de',
  'conditions.operators.gt': 'Mayor que',
  'conditions.operators.gte': 'Mayor o igual a',
  'conditions.operators.lt': 'Menor que',
  'conditions.operators.lte': 'Menor o igual a',
  'conditions.operators.btwn': 'Entre',
  'conditions.operators.nbtwn': 'No está entre',
  'conditions.operators.in': 'Uno de',
  'conditions.operators.any': 'Uno de',
  'conditions.operators.nany': 'No contiene',
  'conditions.operators.exactly': 'Es exactamente',
  'conditions.operators.some': 'Uno de',
  'conditions.operators.all': 'Todos',
  'conditions.operators.every': 'Todos',
  'conditions.operators.within_ids': '',
  'conditions.operators.within_refs': '',
  'conditions.emptyUser': 'vacío',

  // Places
  place: 'Local',
  place_person: 'Persona',

  // Date
  createdAt: 'Creado en',
  'pdf.repliedAt': 'Respondido el {{date}}',
  updatedAt: 'Actualizado en',
  removedBy: 'Removido por',

  // Views
  'views.list': 'Vista de lista',
  'views.calendar': 'Vista de calendario',
  'views.listReplies': 'Vista de lista de respuestas',
  'views.graphics': 'Vista de gráficos',
  newKanban: 'Nuevo Kanban',

  // Widgets
  'widgets.considering': 'Considerando: ',
  'widgets.allTime': 'De todos los tiempos',
  'widgets.perspective': 'Perspectiva',
  'widgets.byHour': 'Por hora',
  'widgets.byDay': 'Por día',
  'widgets.byMonth': 'Por mes',
  'widgets.byYear': 'Por año',
  'widgets.activities': 'Actividades',
  'widgets.forms': 'Formularios',
  'widgets.presentation': 'Presentación',
  'widgets.color': 'Color',
  'widgets.filters': 'Filtros',
  'widgets.ignorePeriod': '¿Ignorar período?',
  'widgets.counterOnly': 'Solo contador',
  'widgets.percentageBar': 'Barra de porcentaje',
  'widgets.circularPercentage': 'Porcentaje circular',
  'widgets.lines': 'Líneas',
  'widgets.bars': 'Barras',
  'widgets.initialPerspective': 'Perspectiva inicial',
  'widgets.hidePerspectiveSelection': '¿Ocultar selección de perspectiva?',
  'widgets.name': 'Nombre',
  'widgets.completed': 'Completadas',
  'widgets.open': 'Abiertas',
  'widgets.pending': 'Pendientes',
  'widgets.compliancesCounter.name': 'Porcentaje de no conformidades',
  'widgets.compliancesCounter.description': 'Lorem Ipsum',
  'widgets.compliancesCounter.category': 'Conformidad',
  'widgets.serviceOrdersCounter.name': 'Conteo de actividades',
  'widgets.serviceOrdersCounter.description': 'Lorem Ipsum',
  'widgets.serviceOrdersCounter.category': 'Actividades',
  'widgets.serviceOrdersCounter.initialStateName': 'Actividades',
  'widgets.noPreview': 'Este widget no tiene vista previa',
  'widgets.nonCompliancesCounter.name': 'Conteo de no conformidades',
  'widgets.nonCompliancesCounter.description': 'Lorem Ipsum',
  'widgets.nonCompliancesCounter.category': 'Conformidad',
  'widgets.nonCompliancesCounter.initialStateName': 'No conformidades',
  'widgets.usersCounter.name': 'Conteo de usuarios',
  'widgets.usersCounter.description': 'Lorem Ipsum',
  'widgets.usersCounter.category': 'Usuarios',
  'widgets.usersCounter.initialStateName': 'Usuarios',
  'widgets.placesCounter.name': 'Conteo de lugares',
  'widgets.placesCounter.description': 'Lorem Ipsum',
  'widgets.placesCounter.category': 'Lugares',
  'widgets.placesCounter.initialStateName': 'Lugares',
  'widgets.formsCounter.name': 'Conteo de formularios',
  'widgets.formsCounter.description': 'Lorem Ipsum',
  'widgets.formsCounter.category': 'Formularios',
  'widgets.formsCounter.initialStateName': 'Formularios',
  'widgets.formRepliesCounter.name': 'Conteo de respuestas de formularios',
  'widgets.formRepliesCounter.description': 'Lorem Ipsum',
  'widgets.formRepliesCounter.category': 'Formularios',
  'widgets.formRepliesCounter.initialStateName': 'Respuestas de formularios',
  'widgets.groupedEventsByReason.name': 'Eventos agrupados por motivo',
  'widgets.groupedEventsByReason.description': 'Lorem Ipsum',
  'widgets.groupedEventsByReason.category': 'Actividades',
  'widgets.averageEventsAmountByPeriod.name': 'Cantidad de actividades promedio ejecutadas por período',
  'widgets.averageEventsAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageEventsAmountByPeriod.category': 'Actividades',
  'widgets.averageFormRepliesAmountByPeriod.name': 'Respuestas de formularios promedio por período',
  'widgets.averageFormRepliesAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageFormRepliesAmountByPeriod.category': 'Formularios',
  'widgets.periodicFormReplies.name': 'Volumen de respuestas de formularios por período',
  'widgets.periodicFormReplies.description': 'Lorem Ipsum',
  'widgets.periodicFormReplies.category': 'Formularios',
  'widgets.periodicServiceOrdersByStatus.name': 'Volumen de actividades por estado',
  'widgets.periodicServiceOrdersByStatus.description': 'Lorem Ipsum',
  'widgets.periodicServiceOrdersByStatus.category': 'Actividades',
  'widgets.periodicNonCompliances.name': 'Volumen de no conformidades por período',
  'widgets.periodicNonCompliances.description': 'Lorem Ipsum',
  'widgets.periodicNonCompliances.category': 'Conformidad',
  'widgets.groupedNonCompliances.name': 'No conformidades por entidad',
  'widgets.groupedNonCompliances.description': 'Lorem Ipsum',
  'widgets.groupedNonCompliances.category': 'Conformidad',
  'widgets.ranking.name': 'Ranking',
  'widgets.ranking.description': 'Lorem Ipsum',
  'widgets.usersRanking.name': 'Ranking de usuarios',
  'widgets.usersRanking.category': 'Usuarios',
  'widgets.placesRanking.name': 'Ranking de lugares',
  'widgets.placesRanking.category': 'Lugares',
  'widgets.checklistsRanking.name': 'Ranking de cuestionarios',
  'widgets.checklistsRanking.category': 'Cuestionarios',
  'widgets.embed.name': 'Contenido embebido',
  'widgets.embed.description': 'Este widget permite incrustar contenido desde dentro y fuera de Btime.',
  'widgets.embed.category': 'Embed',
  'widgets.embed.initialStateName': 'Contenido embebido',
  'widgets.status': 'Estado',
  'widgets.all': 'Todas',
  'widgets.done': 'Completadas',
  'widgets.type': 'Tipo',
  'widgets.groupedBy': 'Agrupado por',
  'widgets.evaluatedCompliances': 'Conformidades evaluadas',
  'widgets.nonCompliances': 'No conformidades',
  'widgets.canceled': 'Canceladas',
  'widgets.questionnaire': 'Cuestionario',
  'widgets.locals': 'Lugares',
  'widgets.user': 'Usuario',
  'widgets.invertPerspective': '¿Invertir perspectiva?',
  'widgets.period': 'Período',
  'widgets.timeOfDay': 'Hora del día',
  'widgets.dayOfWeek': 'Día de la semana',
  'widgets.barColor': 'Color de las barras',
  'widgets.url': 'URL*',
  'widgets.rejected': 'Rechazadas',
  'widgets.approved': 'Aprobadas',
  'widgets.openings': 'Aperturas',
  'widgets.completions': 'Conclusiones',
  'widgets.discontinuations': 'Discontinuaciones',
  'widgets.total': 'Total',
  'widgets.removeScreenItem.confirm': '¿Estás seguro de que deseas eliminar?',
  'widgets.removeScreenItem.success': '¡Pantalla eliminada con éxito!',
  'widgets.removeScreenItem.error': '¡Ocurrió un error al eliminar!',

  'serviceOrders.removeModal.title': 'Las siguientes actividades serán eliminadas',
  'serviceOrders.removeModal.description': 'Al eliminar una actividad, sus hijas también serán eliminadas',
  'serviceOrders.removeActivities': 'Eliminar actividades',
  removeInitialValue: 'Eliminar valor inicial',

  'routines.confirmRemove': '¿Está seguro de que desea eliminar la rutina {{name}}?',
  'routines.removeError': '¡Ocurrió un error al eliminar la rutina!',

  // Filters and lists
  betaVersionMessage: 'Estás viendo la versión beta',
  useOldVersion: 'Usar versión antigua',

  itemsFound: '{{count}} item encontrado',
  itemsFound_plural: '{{count}} items encontrados',

  emptyMessage: '¡No se encontraron datos!',
  errorMessage: '¡Ocurrió un error al conectar con el servidor!',

  // Device info
  deviceModel: 'Modelo',
  battery: 'Batería',
  application: 'Aplicación',
  storage: 'Almacenamiento',

  cleanDate: 'Limpiar fecha',
  selectInitDate: 'Seleccione la fecha de inicio',
  selectEndDate: 'Seleccione la fecha de fin',

  showAll: 'Mostrar todo',
  showOnly: 'Mostrar solo',
  clean: 'Limpiar',
  applyFilters: 'Aplicar Filtros',
  filterBy: 'Filtrar por',
  sortBy: 'Ordenar por',
  ASC: 'Creciente',
  DESC: 'Decreciente',
  cleanFilters: 'Limpiar filtros',
  filter: 'Filtrar',
  sort: 'Ordenar',
  search: 'Buscar',
  selectAll: 'Seleccionar todos',
  selected: 'Seleccionado',
  select: 'Seleccionar',
  selected_plural: 'Seleccionados',

  //Non Compliance
  openActionPlan: 'Abrir plan de acción',
  lastReplies: 'Últimas respuestas',
  ignoreNonCompliance: 'Ignorar',
  removeIgnoreNonCompliance: 'No ignorar',
  completeNonCompliance: 'Marcar como completada',
  markAsCompleted: 'Marcar como completada',
  createActionPlan: 'Crear Plan de Acción',
  'option.replies': 'Respuestas',
  'option.serviceOrders': 'Órdenes de Servicio',

  // General
  metrics: 'Métricas',
  rest: 'Otros',
  pay: 'Pagar',
  files: 'Archivos',
  clone: 'Clonar',
  export: 'Exportar',
  reply: 'Responder',
  details: 'Detalles',
  questions: 'Preguntas',
  simulation: 'Simulación',
  noUser: 'Sin usuario',
  noPlace: 'Sin local',
  changeUser: 'Cambiar usuario',
  execute: 'Ejecutar',
  executeInBulk: 'Ejecutar en lote',
  reopen: 'Reabrir',
  resume: 'Resumen',
  public: 'Público',
  private: 'Privado',
  replies: '{{count}} respuesta',
  replies_plural: '{{count}} respuestas',
  close: 'Cerrar',
  branch: 'Sucursal',
  headquarter: 'Matriz',
  sendQrCodes: 'Enviar QrCodes',
  minimum: 'Min: {{count}}',
  maximum: 'Max: {{count}}',
  tryAgain: 'Intentar nuevamente',
  print: 'Imprimir',
  errorDelete: 'Ocurrió un error al eliminar :(',
  confirmRemove: '¿Está seguro de que desea eliminar?',
  removeSuccess: '¡Eliminado con éxito!',
  clearSelection: 'Limpiar selección',

  create: 'Crear',
  update: 'Actualizar',
  sendForm: 'Enviar form.',
  send: 'Enviar',
  begin: 'Iniciar',
  person: 'Persona',
  location: 'Local',
  types: 'Tipos',
  share: 'Compartir',
  assets: 'Activos',
  field: 'Campo',
  fields: 'Campos',
  seeDetails: 'Ver detalles',
  remove: 'Eliminar',
  docGenerate: 'Generar PDF',
  actions: 'Acciones',
  moreOptions: 'Más Opciones',
  addPhoto: 'Agregar Foto',
  yes: 'Sí',
  no: 'No',
  active: 'Activo',
  inactive: 'Inactivo',
  notAvailable: 'N/A',
  fieldInDevelopment: 'Campo en desarrollo',
  required: 'Obligatorio',
  pause: 'Pausar',
  saveAndPause: 'Guardar y pausar',
  submit: 'Enviar',
  edit: 'Editar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  save: 'Guardar',

  // Question types
  'questions.types.checkbox': 'Checkbox',
  'questions.types.compliance': 'Conformidad',
  'questions.types.text': 'Texto',
  'questions.types.gallery': 'Anexos',
  'questions.types.number': 'Numérico',
  'questions.types.sign': 'Firma',

  // Question answers
  'questions.answers.yes': 'Sí',
  'questions.answers.no': 'No',

  // Actions
  changePassword: 'Cambiar contraseña',
  logs: 'Logs',
  generateCustomDocument: 'Generar Documento Personalizado',
  sendPublicLink: 'Enviar enlace público',
  sendPublicLinks: 'Enviar enlaces públicos',
  sendFormFull: 'Enviar formulario',
  generateQRCode: 'Generar Código QR',
  generateQRCodes: 'Generar Códigos QR',
  createActivities: 'Crear actividades',
  saveAsTemplate: 'Guardar como plantilla',
  recoverUser: 'Recuperar usuario',
  reinstall: 'Reinstalar',
  registerTechnician: 'Registrar Técnico',
  viewTechnicians: 'Ver Técnicos',

  // Status
  changeStatus: 'Cambiar Estado',
  approval: 'Aprobación',
  approve: 'Aprobar',
  disapprove: 'Rechazar',
  'status.reason.approved': 'Motivo de la aprobación',
  'status.reason.canceled': 'Motivo de la cancelación',
  'status.reason.unproductive': 'Motivo de la improductividad',
  'status.reason.refused': 'Motivo de haber rechazado',
  'status.reason.disapproved': 'Motivo del rechazo',
  'status.reason.closing': 'Motivo de cierre',
  'status.action.approved': 'Aprobar',
  'status.action.disapproved': 'Rechazar',
  'status.action.canceled': 'Cancelar',
  'status.pastAction.request': 'Abrió solicitud',
  'status.pastAction.open': 'abrió',
  'status.pastAction.received': 'recibió',
  'status.pastAction.accept': 'aceptó',
  'status.pastAction.refused': 'rechazó',
  'status.pastAction.execution': 'ejecutó',
  'status.pastAction.pause': 'pausó',
  'status.pastAction.unproductive': 'marcó como improductiva',
  'status.pastAction.completed': 'completó',
  'status.pastAction.pending': 'dejó pendiente',
  'status.pastAction.canceled': 'canceló',
  'status.pastAction.approved': 'aprobó',
  'status.pastAction.disapproved': 'rechazó',
  'status.pastAction.resolved': 'resolvió',
  'status.pastAction.unresolved': 'marcó como no resuelta',
  'status.pastAction.actionPlan': 'creó plan de acción',
  'status.pastAction.closing': 'cerró',
  'status.all': 'Todas',
  'status.request': 'Solicitud',
  'status.open': 'Abierta',
  'status.received': 'Recibida',
  'status.accept': 'Aceptada',
  'status.refused': 'Rechazada',
  'status.execution': 'Ejecución',
  'status.pause': 'Pausada',
  'status.unproductive': 'Improductiva',
  'status.completed': 'Completada',
  'status.pending': 'Pendiente',
  'status.canceled': 'Cancelada',
  'status.approved': 'Aprobada',
  'status.disapproved': 'Rechazada',
  'status.resolved': 'Resuelta',
  'status.unresolved': 'No Resuelta',
  'status.actionPlan': 'Plan de Acción',
  'status.request_plural': 'Solicitudes',
  'status.open_plural': 'Abiertas',
  'status.received_plural': 'Recibidas',
  'status.accept_plural': 'Aceptadas',
  'status.refused_plural': 'Rechazadas',
  'status.execution_plural': 'Ejecuciones',
  'status.pause_plural': 'Pausadas',
  'status.unproductive_plural': 'Improductivas',
  'status.completed_plural': 'Completadas',
  'status.pending_plural': 'Pendientes',
  'status.canceled_plural': 'Canceladas',
  'status.approved_plural': 'Aprobadas',
  'status.disapproved_plural': 'Rechazadas',
  'status.resolved_plural': 'Resueltas',
  'status.unresolved_plural': 'No Resueltas',
  'status.actionPlan_plural': 'Planes de Acción',
  'status.done': 'Completadas',
  'status.ignored': 'Ignorada',
  'status.ignored_plural': 'Ignoradas',
  'status.closing': 'Cierre',
  'status.closing_plural': 'Cierres',

  'status.inProgress': 'En progreso',
  'status.inProgress_plural': 'En progreso',

  'priority.critical': 'Crítica',
  'priority.high': 'Alta',
  'priority.medium': 'Media',
  'priority.low': 'Baja',

  // Actions
  complete: 'Completar',
  generatePDFSummary: 'Generar Resumen en PDF',
  createChildActivity: 'Crear hija',

  'month.1': 'Ene',
  'month.2': 'Feb',
  'month.3': 'Mar',
  'month.4': 'Abr',
  'month.5': 'May',
  'month.6': 'Jun',
  'month.7': 'Jul',
  'month.8': 'Ago',
  'month.9': 'Sep',
  'month.10': 'Oct',
  'month.11': 'Nov',
  'month.12': 'Dic',

  'counter.text': 'Registros encontrados',
  requeue_failed_tasks: 'Reejecutar tareas falladas',
  retry_failed_confirm: '¿Estás seguro de que deseas reejecutar las tareas fallidas?',

  // Errors
  error: 'Error',
  'errors.duplicateRecord': 'No es posible agregar registros duplicados!',
  'errors.cannotRemoveHasUsers': 'No fue posible eliminar. Hay al menos un usuario con este elemento.',
  insufficientAmount: 'Cantidad insuficiente',
  valueMustBeGreaterThanZero: 'La cantidad debe ser mayor que cero',
  'assets.generateQrCode': 'Generar código QR',
  'assets.generateQrCodes': 'Generar códigos QR',
  'processes.remove.success': '¡Proceso eliminado con éxito!',
  'screens.remove.success': '¡Pantalla eliminada con éxito!',
  'screenViews.remove.success': '¡Visión eliminada con éxito!',
  'errors.remove': '¡Ocurrió un error al eliminar!',

  // ModalPicker
  selectOneOrMore: 'Seleccione uno o más:',
  include: 'Incluir',
  disabled: 'Desactivados',
  deleted: 'Eliminados',

  // IconPicker
  selectOne: 'Seleccione uno',
  icon: 'ícono',
  removeSelection: 'Eliminar selección',

  // LevelSection
  levelConfiguration: 'Configuración de Nivel',
  selectLevelToApplyConfiguration:
    'Seleccione un nivel para aplicar esta configuración solo a los niveles seleccionados.',
  type: 'Tipo',
  level: 'Nivel',

  // Common entities
  activities: 'Actividades',
  user: 'Usuario',
  users: 'Usuarios',
  group: 'Grupo',
  status: 'Estado',
  tag: 'Tag',
  selectStatus: 'Selección de estado',
  automatic: 'Automático',
  asset: 'Activo',
  views: 'Vistas',
  places: 'Locales',
  people: 'Personas',
  fleets: 'Flotas',
  creationDate: 'Fecha de creación',
  schedulingDate: 'Fecha de agendamiento',
  completionDate: 'Fecha de conclusión',
  dates: '{{count}} fechas',
  opening: 'Apertura',
  sla: 'SLA',
  overdue: 'En Atraso',
  id: 'ID',
  showDeleted: 'Mostrar eliminados',
  documentsCount: '{{count}} documento(s)',
  actionPlansCount: '{{count}} plano(s) de acción',
  'config.service_order_started_since_colors.normal': 'Normal',
  'config.service_order_started_since_colors.warning': 'Aviso',
  'config.service_order_started_since_colors.critic': 'Crítico',

  // Date Picker
  'datePicker.selectDate': 'Selección de fecha',
  'datePicker.suggestions': 'Sugerencias',
  'datePicker.today': 'Hoy',
  'datePicker.yesterday': 'Ayer',
  'datePicker.currentWeek': 'Semana actual',
  'datePicker.lastWeek': 'Semana pasada',
  'datePicker.currentMonth': 'Mes actual',
  'datePicker.lastMonth': 'Mes pasado',
  'datePicker.currentQuarter': 'Trimestre actual',
  'datePicker.lastQuarter': 'Trimestre pasado',
  'datePicker.currentYear': 'Año actual',
  'datePicker.lastYear': 'Año pasado',
  'datePicker.last3Years': 'Últimos 3 años',
  'datePicker.last5Years': 'Últimos 5 años',
  'datePicker.next7Days': 'Próximos 7 días',
  reopenActivity: 'Reabrir Actividad',
  finish: 'Finalizar',

  // Modals
  'modals.editingUser': 'Editando usuario',
  'modals.creatingUser': 'Creando usuario',
  'modals.changingPassword': 'Cambiando contraseña',
  'modals.editingUsers': 'Editando usuarios',
  'modals.registeringUsers': 'Registrando usuarios',
  'modals.editGroup': 'Editar Grupo',
  'modals.createGroup': 'Crear Grupo',
  'modals.editChecklistCategory': 'Editar Categoría del Cuestionario',
  'modals.createChecklistCategory': 'Crear Categoría del Cuestionario',
  'modals.editMinicrud': 'Editar',
  'modals.createMinicrud': 'Crear',
  'modals.editingPlace': 'Editando local',
  'modals.creatingPlace': 'Creando local',
  'modals.customizeLevels': 'Personalizar niveles',
  'modals.editingPlaceLevel': 'Editando nivel de locales',
  'modals.creatingPlaceLevel': 'Creando nivel de locales',
  'modals.editingTag': 'Editando tag',
  'modals.creatingTag': 'Creando tag',
  'modals.tagsList': 'Tags de Actividad',
  'modals.editingPlaceType': 'Editando Tipo de locales',
  'modals.creatingPlaceType': 'Creando Tipo de locales',
  'modals.registeringItems': 'Registrando Ítems',
  'modals.editingProfile': 'Editando perfil',
  'modals.creatingProfile': 'Creando perfil',
  'modals.cloningProcess': 'Clonando proceso',
  'modals.editingProcess': 'Editando proceso',
  'modals.creatingProcess': 'Creando proceso',
  'modals.cloningScreen': 'Clonando pantalla',
  'modals.editingScreen': 'Editando pantalla',
  'modals.creatingScreen': 'Creando pantalla',
  'modals.cloningColumn': 'Clonando columna',
  'modals.editingColumn': 'Editando columna',
  'modals.creatingColumn': 'Creando columna',
  'modals.editingWidget': 'Editando widget',
  'modals.addingWidget': 'Agregando widget',
  'modals.editingServiceOrderUser': 'Editando Usuario Responsable',
  'modals.editingStatus': 'Editando Estado',
  'modals.exportingServiceOrders': 'Exportando actividad(es)',
  'modals.replyingServiceOrder': 'Respondiendo actividad',
  'modals.serviceOrderResume': 'Resumen de la actividad',
  'modals.cloningServiceOrder': 'Clonando actividad',
  'modals.editingServiceOrder': 'Editando actividad',
  'modals.creatingServiceOrder': 'Creando actividad',
  'modals.editingServiceOrders': 'Editando actividades',
  'modals.registeringServiceOrders': 'Registrando actividades',
  'modals.sendingPublicExecutionLink': 'Enviando enlace público de ejecución',
  'modals.replies': 'Respuestas',
  'modals.editingDynamicServiceOrders': 'Editando Actividades Dinámicas',
  'modals.creatingDynamicServiceOrders': 'Creando Actividades Dinámicas',
  'modals.editingStockItem': 'Editando ítem',
  'modals.creatingStockItem': 'Creando ítem',
  'modals.details': 'Detalles',
  'modals.transfers': 'Transferencias',
  'modals.transferHistory': 'Historial de transferencias',
  'modals.formEdit': 'Edición de Formulario',
  'modals.formsEdit': 'Edición de Formularios',
  'modals.formReply': 'Respuesta del Formulario',
  'modals.actionPlans': 'Planes de acción',
  'modals.editingAsset': 'Editando Ítem',
  'modals.creatingAsset': 'Registrando Ítem',
  'modals.templatesList': 'Listado de Plantillas',
  'modals.editingTemplate': 'Editando plantilla',
  'modals.creatingTemplate': 'Creando plantilla',
  'modals.templateDetails': 'Detalles de Plantilla',
  'modals.documentGeneration': 'Generación de Documento',
  'modals.documentsHistory': 'Historial de Documentos',
  'modals.cloningChecklist': 'Clonando cuestionario',
  'modals.chooseTemplate': 'Elija una plantilla',
  'modals.automations': 'Automatizaciones',
  'modals.templates': 'Plantillas',
  'modals.automationDetails': 'Detalles de la Automatización',
  'modals.editingAutomation': 'Editando automatización',
  'modals.creatingAutomation': 'Creando automatización',
  'modals.triggerFired': 'Gatillo disparado',
  'modals.qrCodeMenus': 'Menús de Código QR',
  'modals.editingLinktree': 'Editando Linktree',
  'modals.creatingLinktree': 'Creando Linktree',
  'modals.publicLinks': 'Enlaces Públicos',
  'modals.editPublicToken': 'Editar token Público',
  'modals.newPublicToken': 'Nuevo token Público',
  'modals.publicToken': 'Token Público',
  'modals.newIntegration': 'Nueva integración',
  'modals.newAccount': 'Nueva cuenta',
  'modals.editingWebhook': 'Editando webhook',
  'modals.creatingWebhook': 'Creando webhook',
  'modals.newConfiguration': 'Nueva configuración',
  'modals.webhookDetails': 'Detalles del webhook',
  'modals.routines': 'Rutinas',
  'modals.editingRoutine': 'Editando rutina',
  'modals.creatingRoutine': 'Creando rutina',
  'modals.editingPermissions': 'Editando permisos',
  'modals.nonCompliance': 'No conformidad',
  'modals.nonComplianceBulkEdit': 'Edición masiva de no conformidad',
  'modals.actionPlan': 'Plan de Acción',
  'modals.imports': 'Importaciones',
  'modals.export': 'Exportación',
  'modals.exports': 'Exportaciones',
  'modals.buckets': 'Lotes',
  'modals.newBucket': 'Nuevo lote',
  'modals.editingView': 'Editando vista',
  'modals.editingFields': 'Editando campos adicionales',
  'modals.createStrongPassword': 'Crear una contraseña fuerte',
  'modals.alert': 'Alerta',
  'modals.formInvites': 'Envío de invitaciones',
  'modals.semaphoreConfig': 'Configuración de semáforo',
  'modals.availabilityStatusSourceConfig': 'Origen del Estado de Disponibilidad',
  'modals.automaticDistribution': 'Distribución automática',
  'modals.survey': 'Encuesta',
  'modals.generatingQrCode': 'Generando Código QR',
  'modals.generatingQrCodes': 'Generando Códigos QR',
  'modals.groupedItems': 'Ítems agrupados',
  'modals.newTechnician': 'Nuevo técnico',
  'modals.registeredTechnicians': 'Técnicos Registrados'
}
